export default __webpack_public_path__ + "maps-examples-line-gradient-thumbnail-960-236ca3807f6e81501ad33f7752c16e49.png";